var Backbone = require('backbone');
var _ = require('underscore');

require('./IndexNotMember.less');


module.exports = Backbone.View.extend({

    el: '.IndexNotMember',

    events: {
        'click input': 'resetErrorState',
        'change input': 'resetErrorState',
        'focus  input': 'resetErrorState',
        'input input': 'resetErrorState',

        'click .IndexNotMember-button': 'onSubmitClick'
    },


    initialize: function () {
        app.utils.phoneInputHandler({
            phone0: this.$('input[name="PhoneNumber0"]'),
            phone1: this.$('input[name="PhoneNumber1"]'),
            phone2: this.$('input[name="PhoneNumber2"]')
        });

        app.utils.phoneInputHandler({
            phone0: this.$('input[name="ArtDepartmentPhoneNumber0"]'),
            phone1: this.$('input[name="ArtDepartmentPhoneNumber1"]'),
            phone2: this.$('input[name="ArtDepartmentPhoneNumber2"]')
        });
    },


    resetErrorState: function (e) {
        $(e.currentTarget)
            .closest('.IndexNotMember-inputLine')
            .removeClass('IndexNotMember-inputLine--error IndexNotMember-inputLine--error-with-input');
    },


    show: function () {
        this.$el.addClass('visible');
    },


    hide: function () {
        this.$el.removeClass('visible');
    },


    checkRequired: function (params) {
        var hasError = false;
        var self = this;

        //check form inputs
        this.$('.IndexNotMember-inputName--required').each(function (ind, item) {
            if (hasError) return;

            var $wrapper = $(item).closest('.IndexNotMember-inputLine');
            var $input = $('input', $wrapper).eq(0);
            var inputName = $input.attr('name');
            var inputType = $input.attr('type');

            if (inputType == 'radio') {
                var val = self.$('input[name="' + inputName + '"]:checked').val();

                if (val == undefined) {
                    $wrapper.addClass('IndexNotMember-inputLine--error');
                    hasError = true;

                    return;
                }
            } else {
                var val = $.trim($input.val());

                /*eslint-disable */
                if (inputName == 'PhoneNumber0') {
                    val = $('input', $wrapper).eq(0).val() && $('input', $wrapper).eq(1).val() && $('input', $wrapper).eq(2).val();
                }

                if (inputName == 'ArtDepartmentPhoneNumber0') {
                    val = $('input', $wrapper).eq(0).val() && $('input', $wrapper).eq(1).val() && $('input', $wrapper).eq(2).val();
                }
                /*eslint-enable */

                if (!val) {
                    params.focusOnError && $input.focus();
                    $wrapper.addClass('IndexNotMember-inputLine--error-with-input');
                    hasError = true;

                    return;
                }
            }
        });

        return !hasError;
    },


    getFormData: function () {
        var data = {
            'UserName':  this.$('input[name="UserName"]').val(),
            'PhoneNumber': this.$('input[name="PhoneNumber0"]').val() + '-' + this.$('input[name="PhoneNumber1"]').val() + '-' + this.$('input[name="PhoneNumber2"]').val(),
            'Position': this.$('input[name="Position"]').val(),
            'NameOfShow': this.$('input[name="NameOfShow"]').val(),
            'ProductionCompany': this.$('input[name="ProductionCompany"]').val(),
            'ArtDepartmentCoordinator': this.$('input[name="ArtDepartmentCoordinator"]').val(),
            'ArtDepartmentPhoneNumber': this.$('input[name="ArtDepartmentPhoneNumber0"]').val() + '-' + this.$('input[name="ArtDepartmentPhoneNumber1"]').val() + '-' + this.$('input[name="ArtDepartmentPhoneNumber2"]').val(),
            'ProductionDesigner': this.$('input[name="ProductionDesigner"]').val(),
            'Location': this.$('input[name="Location"]').val()
        };

        if (!this.$('input[name="ArtDepartmentPhoneNumber0"]').val() || !this.$('input[name="ArtDepartmentPhoneNumber1"]').val() || !this.$('input[name="ArtDepartmentPhoneNumber2"]').val()) {
            data.ArtDepartmentPhoneNumber = '';
        }

        console.log(data);

        return data;
    },


    onSubmitClick: function () {
        if (!this.checkRequired({focusOnError: true})) return;

        var data = this.getFormData();

        this.trigger('submit', data);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/availability/components/IndexNotMember/IndexNotMember.js
// module id = 19
// module chunks = 0